import React from "react";
import footerLogo from "../../assets/images/footer-logo.png";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";
import { MAIN } from "../../Router/paths";

export default function Footer() {
  return (
    <footer className="mt-5">
      <div className="container-fluid px-5">
        <div className="footer mb-3">
          <div className="row">
            <div className="col-lg-3">
              <div className="footer-content primary-heading color-light">
                <div className="footer-logo mc-b-2">
                  <img src={footerLogo} alt="Logo" />
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="footer-content mc-l-4">
                <h3 className="mc-b-2">Quick links</h3>
                <ul className="footer-list">
                  <li>
                    <Link to={MAIN.aboutUs}> About Us </Link>
                  </li>
                  <li>
                    <Link to={MAIN.contactUs}> Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="footer-content">
                <h3 className="mc-b-2">Useful links</h3>
                <ul className="footer-list">
                  <li>
                    <Link to={MAIN.terms}> Terms &amp; Conditions </Link>
                  </li>
                  <li>
                    <Link to={MAIN.privacy}> Privacy Policy </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="footer-content mc-l-2">
                <h3 className="mc-b-2">Follow Us</h3>
                <ul className="footer-social">
                  <li>
                    <Link to={"#"}>
                      <FaFacebook />
                    </Link>
                  </li>
                  <li>
                    <Link to={"#"}>
                      <FaInstagram />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="copyright text-center">
            <div className="row">
              <div className="col-lg-6 col-center">
                <div className="primary-heading color-light">
                  <p>Copyright © Bnr360.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
